import React from 'react'
import { Grid, Typography } from '@material-ui/core'
import mediabankLogo from '../../mediabank.png'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    root: {},
    logo: { marginRight: theme.spacing(2) }
}))

const Header = () => {
    const classes = useStyles()
    return (
        <Grid container item xs={12}>
            <Grid item>
                <img
                    src={mediabankLogo}
                    alt="logo"
                    width={64}
                    height={49}
                    className={classes.logo}
                />
            </Grid>
            <Grid item>
                <Typography variant="h1" color={'textPrimary'}>
                    Usage estimates calculator
                </Typography>
            </Grid>
        </Grid>
    )
}

export default Header
